<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div class="nav" title="HuiYiDetailBaoZhangList" data-title="报账管理">
      <c_cell title="报账金额">
        <c_money
          :key="state.statistics?.total_amount"
          :value="state.statistics?.total_amount"
          :prefix="false"
          bold
          color="#000"
        />
      </c_cell>
      <el-button
        type="primary"
        icon="Tickets"
        link
        @click="
          delete state.selectId;
          delete state.mingxi_search;
          state.showMingXi = true;
        "
        class="ml-5"
      >
        费用明细管理
      </el-button>
      <el-button
        type="primary"
        :icon="Document"
        link
        @click="
          delete state.select_place;
          delete state.build_search;
          state.build_title = `生成总账单`;
          state.showBuild = true;
        "
        v-if="
          state.meeting?.is_need_generate_bill_record ||
          !state.meeting?.is_generate_bill_record
        "
      >
        生成总账单
      </el-button>
      <el-button
        type="warning"
        :icon="Search"
        link
        @click="
          delete state.select_place;
          state.build_search = true;
          state.build_title = `查看总账单`;
          state.showBuild = true;
        "
        v-else
      >
        查看总账单
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column label="分会名称">
          <template #default="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template #default="{ row }">
            <c_status
              :key="row.type"
              arrName="Meeting_Place_Type"
              :value="row.type"
              class="m-auto"
            />
          </template>
        </el-table-column>
        <el-table-column label="乙方">
          <template #default="{ row }">
            <div class="flex items-center">
              <text>{{ row.billUnit?.name }}</text>
              <text class="text-gray-400 text-xs ml-1">
                {{ "[" + row.billUnit?.number + "]" }}
              </text>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="费用项目" align="center">
          <template #default="{ row }">
            <strong class="text-green-600">{{ row.count }}</strong>
          </template>
        </el-table-column>
        <el-table-column
          label="报账金额"
          prop="amount"
          align="center"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="状态" align="center" :width="160">
          <template #default="{ row }">
            <text v-if="!row.is_generate_bill_record">未生成</text>
            <template v-else>
              <text
                v-if="row.is_need_generate_bill_record"
                style="color: var(--el-color-danger)"
              >
                需重新生成
              </text>
              <text v-else style="color: var(--el-color-success)">
                已生成
              </text>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Document"
              link
              v-if="
                row.is_need_generate_bill_record || !row.is_generate_bill_record
              "
              @click="
                state.select_place = row;
                delete state.build_search;
                state.build_title = `生成分会《${row.name}》报账单`;
                state.showBuild = true;
              "
            >
              生成报账单
            </el-button>
            <el-button
              v-else
              type="primary"
              :icon="Search"
              link
              @click="
                state.select_place = row;
                state.build_search = true;
                state.build_title = `查看分会《${row.name}》报账单`;
                state.showBuild = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showMingXi"
    title="费用明细管理"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showMingXi = false;
        onLoad();
      }
    "
    width="95%"
    style="height: 95%; max-height: 95%"
  >
    <c_mingxi
      :meeting_id="props.meeting_id"
      :meeting_bill_id="state.selectId"
      :id="state.selectId"
      :search="state.mingxi_search"
      @close="
        state.showMingXi = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showBuild"
    :title="state.build_title"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showBuild = false;
      }
    "
    width="80%"
    style="height: 80%; max-height: 80%"
  >
    <c_build
      :meeting_id="props.meeting_id"
      :meeting_place_id="state.select_place?.id"
      @close="
        () => {
          state.showBuild = false;
          onLoad();
        }
      "
      :search="state.build_search"
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, watch } from "vue";
import { meeting_bill_page } from "@/http/meeting";

import c_mingxi from "./FeiYongMingXi/List.vue";
import c_build from "./Build.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
    tax_fee_rate: Number,
  },
  components: {
    c_mingxi,
    c_build,
  },
  setup(props, { emit }) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    watch(
      () => props.tax_fee_rate,
      (newVal) => {
        onLoad();
      },
    );

    const onLoad = () => {
      delete state.list_data;
      meeting_bill_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count, statistics, meeting } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
          state.meeting = meeting;
          state.statistics = statistics;
        }
      });
    };

    return { state, props, onLoad };
  },
};
</script>

<style lang="scss" scoped></style>
